// Module
var code = "<kubernetes-summary-view-react actions=\"$ctrl.state.resources\" cpu-limit=\"$ctrl.state.limits.cpu\" memory-limit=\"$ctrl.state.limits.memory\"></kubernetes-summary-view-react>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/kubernetes/views/summary/summary.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;